// src/pages/Chats.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../firebaseConfig";



export default function Chats() {
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const colRef = collection(db, "chats");
    const q = query(colRef, orderBy("lastMessageAt", "desc"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const list = snap.docs.map((doc) => ({
          id: doc.id, // userId
          ...doc.data(),
        }));
        setChats(list);
        setLoading(false);
      },
      (err) => {
        console.error("Error leyendo chats:", err);
        setLoading(false);
      }
    );

    return () => unsub();
  }, []);

  const formatearFecha = (ts) => {
    if (!ts) return "";
    if (ts.toDate) return ts.toDate().toLocaleString();
    return String(ts);
  };

  return (
    <div>
      <h1>Chats</h1>
      <p style={{ color: "#6b7280", marginBottom: "1rem" }}>
        Lista de chats entre usuarios y administrador.
      </p>

      {loading && <p>Cargando chats...</p>}

      {!loading && chats.length === 0 && <p>No hay chats todavía.</p>}

      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        {chats.map((chat) => (
          <button
            key={chat.id}
            onClick={() => navigate(`/chats/${chat.id}`)}
            style={{
              width: "100%",
              textAlign: "left",
              padding: "0.75rem 1rem",
              borderRadius: "0.75rem",
              border: "1px solid #e5e7eb",
              background: "white",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600 }}>
                {chat.userName || chat.userEmail || chat.id}
              </div>
              <div
                style={{
                  fontSize: "0.875rem",
                  color: "#4b5563",
                  marginTop: 2,
                }}
              >
                {chat.lastMessage || "Sin mensajes aún"}
              </div>
            </div>

            <div style={{ textAlign: "right", fontSize: "0.8rem" }}>
              <div>{formatearFecha(chat.lastMessageAt)}</div>
              {chat.unreadForAdmin && (
                <span
                  style={{
                    display: "inline-block",
                    marginTop: 4,
                    padding: "0.15rem 0.5rem",
                    borderRadius: "999px",
                    background: "#ef4444",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                >
                  Nuevo
                </span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
